import api from "@/api/api-v2-config";

export async function getVehicleListAxios() {    
    return await api.get("distributions/vehicles?PageNumber=1&PageSize=10000");
}

export async function deleteVehicleAxios(id) {    
    return await api.delete("distributions/vehicles?vehicleid=" + id);
}

export async function postVehicleAxios(vehicles) {    
    return await api.post("distributions/vehicles", vehicles);
}

export async function putVehicleAxios(vehicles) {    
    return await api.put("distributions/vehicles", vehicles);
}

export async function getVehicleByIDAxios(id) {    
    return await api.get("distributions/vehiclebyid?vehicleid=" + id);
}